<template>
  <v-container class="fill-height" fluid>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="(item, index) in items">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            @click="activaItem(index)"
          >
            <template v-slot:activator>
              <v-list-item-action class="ma-0 mr-2">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
              :to="child.modulo"
              class="pr-2"
            >
              <v-list-item-action v-if="child.icon" class="ma-0 mr-2 ml-7">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            :key="item.text"
            link
            :to="item.modulo"
            @click="activaItem(index)"
          >
            <v-list-item-action class="ma-0 mr-2">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <div class="pa-2" style="bottom: 0px; position: absolute; width: 100%;">
        <img
          :src="logo2URL"
          style="max-width:100%; max-height:50px; margin: auto; display: block;"
        />
      </div>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-slide-x-transition hide-on-leave>
        <div style="width: 225px; height: 55px;" v-show="drawer">
          <img
            :src="logoURL"
            style="max-width:100%; max-height:50px; margin: auto; margin-top: 2px; display: block;"
          />
        </div>
      </v-slide-x-transition>
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        :class="drawer ? 'ml-6' : 'ml-0'"
      ></v-app-bar-nav-icon>
      <v-toolbar-title style="width: 230px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">Gestión de Vehículos</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="white" v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="opc in opciones"
            :key="opc.codigo"
            @click="opcion(opc.codigo)"
          >
            <v-list-item-title>{{ opc.descripcion }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-main class="fill-height" fluid>
      <v-container class="fill-height" fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-snackbar
      v-model="getAlerta2.visible"
      :color="getAlerta2.color"
      :timeout="getAlerta2.tiempo"
      right
      top
    >
      {{ getAlerta2.mensaje }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="hideAlerta2"
          >Cerrar</v-btn
        >
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
export default {
  name: "Index",
  data: () => ({
    dialog: false,
    source: "",
    drawer: false,
    items: [],
    logoURL: process.env.VUE_APP_BASE_PATH + `/api/config/GetImagen?id=logo2`,
    logo2URL: process.env.VUE_APP_BASE_PATH + `/api/config/GetImagen?id=logo3`,
    opciones: [
      {
        codigo: "S",
        descripcion: "Cerrar sesión"
      }
    ]
  }),
  computed: { ...mapGetters(["getToken", "getAlerta2", "getLogin"]) },
  methods: {
    ...mapActions(["setToken", "setLogin", "showAlerta2", "hideAlerta2"]),
    async obtenerRol() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + "/api/usuario/ObtenerRol",
          {
            headers: { Authorization: `Bearer ${this.getToken}` }
          }
        );
      } catch (error) {
        this.loading = false;
        switch (error.response.status) {
          case 400:
            this.showAlerta2({
              mensaje: error.response.data.error_description,
              tipo: 3
            });
            break;
          case 401:
            this.salir();
            break;
        }

        return;
      }

      this.items = [];
      const permisos = respuesta.data.permisos;
      const moduloAdmin = permisos.some(
        x => x.vista.includes("ADMINISTRACION") && x.lectura
      );

      let itemAdmin;
      let modulo;

      if (moduloAdmin) {
        itemAdmin = {
          icon: "mdi-account-cog",
          "icon-alt": "mdi-account-cog",
          text: "Administración",
          codigo: "ADMINISTRACION",
          children: [],
          model: false
        };

        this.items.push(itemAdmin);
      }

      permisos.forEach(el => {
        if (!el.lectura) {
          return;
        }

        switch (el.vista) {
          case "ADMINISTRACION.ROLES":
            modulo = "/Index/Roles";
            itemAdmin.children.push({
              icon: "mdi-account-group",
              text: "Roles",
              modulo: modulo,
              codigo: el.vista
            });
            if (modulo == this.$router.currentRoute.path) {
              itemAdmin.model = true;
            }
            break;
          case "ADMINISTRACION.USUARIOS":
            modulo = "/Index/Usuarios";
            itemAdmin.children.push({
              icon: "mdi-account-multiple",
              text: "Usuarios",
              modulo: modulo,
              codigo: el.vista
            });
            if (modulo == this.$router.currentRoute.path) {
              itemAdmin.model = true;
            }
            break;
          case "ADMINISTRACION.CONFIGURACION":
            modulo = "/Index/Configuracion";
            itemAdmin.children.push({
              icon: "mdi-format-list-bulleted",
              text: "Configuración",
              modulo: modulo,
              codigo: el.vista
            });
            if (modulo == this.$router.currentRoute.path) {
              itemAdmin.model = true;
            }
            break;
          case "CUENTA":
            this.items.push({
              icon: "mdi-account",
              text: "Cuenta",
              modulo: "/Index/Cuenta",
              codigo: el.vista
            });
            break;
          case "VEHICULOS":
            this.items.push({
              icon: "mdi-car-multiple",
              text: "Vehículos",
              modulo: "/Index/Vehiculos",
              codigo: el.vista
            });
            break;
          case "CITA":
            this.items.push({
              icon: "mdi-pencil-plus-outline",
              text: "Nueva cita",
              modulo: "/Index/Cita",
              codigo: el.vista
            });
            break;
          case "HISTORIAL":
            this.items.push({
              icon: "mdi-history",
              text: "Historial citas",
              modulo: "/Index/Historial",
              codigo: el.vista
            });
            break;
          case "PLANIFICACION":
            this.items.push({
              icon: "mdi-calendar-edit",
              text: "Planificación citas",
              modulo: "/Index/Planificacion",
              codigo: el.vista
            });
            break;
        }
      });

      this.items.push({
        icon: "mdi-bullhorn-outline",
        text: "Publicidad",
        modulo: "/Index/Publicidad"
      });

      this.items.push({
        icon: "mdi-phone",
        text: "Contacto",
        modulo: "/Index/Contacto"
      });

      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          break;
        case "sm":
          break;
        case "md":
          break;
        case "lg":
          this.drawer = true;
          break;
        case "xl":
          this.drawer = true;
          break;
      }

      // if (this.getLogin && respuesta.data.cliente) {
      //   this.setLogin(false);
      //   this.$router.push({ path: "/Index/Publicidad" });
      // }
    },
    activaItem(index) {
      this.items.forEach((val, idx) => {
        if (idx != index && val.children) {
          val.model = false;
        }
      });
    },
    opcion(opcion) {
      switch (opcion) {
        case "S":
          this.salir();
          break;
      }
    },
    salir() {
      this.setToken("");
      this.$router.push({ path: "/Login" });
    }
  },
  created() {
    this.obtenerRol();
  }
};
</script>

<style>
.input-decimal input {
  text-align: right;
}
.input-decimal input::placeholder {
  text-align: left;
}
</style>
